import { useTranslation } from "react-i18next";
import Navbar from "@/components/Layout/Navbar";
import Footer from "@/components/Layout/Footer";
import HeroSection from "@/components/Home/HeroSection";
import WhySection from "@/components/Home/WhySection";
import HowSection from "@/components/Home/HowSection";
import CTASection from "@/components/Home/CTASection";
import WhyAfricaSection from "@/components/SEO/WhyAfricaSection";
import FAQSection from "@/components/SEO/FAQSection";
import RelatedLinks from "@/components/SEO/RelatedLinks";
import TrustBar from "@/components/EEAT/TrustBar";
import AuthorBio from "@/components/EEAT/AuthorBio";
import SEOHead from "@/components/SEOHead";
import { PAGE_SEO_CONFIG } from "@/lib/seo";
import { HOME_FAQS_DE, HOME_FAQS_EN } from "@/lib/seoFaqs";

const Index = () => {
  const seoConfig = PAGE_SEO_CONFIG.home;
  const { i18n } = useTranslation();
  const isDe = i18n.language === "de";
  const faqs = isDe ? HOME_FAQS_DE : HOME_FAQS_EN;

  return (
    <div className="min-h-screen bg-background">
      <SEOHead
        titleEn={seoConfig.titleEn}
        titleDe={seoConfig.titleDe}
        descriptionEn={seoConfig.descriptionEn}
        descriptionDe={seoConfig.descriptionDe}
        keywords={seoConfig.keywords}
        path={seoConfig.path}
        includeOrganization={true}
        includeWebsite={true}
        includeService={true}
        faqs={faqs}
        breadcrumbs={[
          { name: 'Home', nameDE: 'Startseite', url: '/' }
        ]}
      />
      <Navbar />
      <main>
        <HeroSection />
        <TrustBar />
        <WhySection />
        <WhyAfricaSection />
        <HowSection />
        <FAQSection
          title={isDe ? "Häufige Fragen zu Nearshore-Softwareentwicklung in Afrika" : "FAQ — Nearshore Software Development Company in Africa"}
          intro={isDe ? "Antworten auf die häufigsten Fragen deutscher Unternehmen zu Nearshore-Softwareentwicklung aus Afrika." : "Answers to the most common questions European companies ask about nearshore software development from Africa."}
          items={faqs}
        />
        <section className="py-24 border-t border-border/60">
          <div className="container mx-auto px-6 max-w-3xl">
            <AuthorBio
              authorId="sherif-adel"
              reviewedByDe="Evolvice Editorial Team"
              reviewedByEn="Evolvice Editorial Team"
            />
          </div>
        </section>
        <RelatedLinks />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
